import React, { useEffect, useState } from 'react';
import { useSpring, useTransition, animated } from 'react-spring';
import { Link } from "react-router-dom";
import { menus } from "../data";
import '../styles/Switch.css';

export default function SwitchContent() {
    const [isActive, setActive] = useState();

    const url = window.location.href.split("/");
    useEffect(() => {
        if (url[4]) {
            const getUrlPosition = menus.filter((item) => item.link === url[4])
            setActive(getUrlPosition[0] && getUrlPosition[0].id ? getUrlPosition[0].id : 0)
        } else {
            setActive(0)
        }
    }, [url])


    const props = useSpring({
        to: { opacity: 1, bottom: 95 },
        from: { opacity: 0, bottom: -10 }
    })

    const menuTransitions = useTransition(menus, item => item.id, {
        from: { paddingLeft: 15, paddingRight: 15 },
        enter: { paddingLeft: 8, paddingRight: 8 },
        leave: { paddingLeft: 5, paddingRight: 5 },
    })

    return (
        <animated.div style={props} className="switch p-2 d-flex justify-content-center">
            {menuTransitions.map(({ item, props, key }) =>
                <animated.div key={key} style={props}>
                    <animated.div
                        key={key}
                        style={props}
                        onClick={() => setActive(item.id)}
                        className="cursor-pointer"
                    >
                        <Link
                            className={isActive === item.id ? "active" : "inactive"}
                            to={`${item.link}`}>
                            {item.menu}
                        </Link>
                    </animated.div>
                </animated.div>
            )}
        </animated.div>
    )
}
